import React from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import ConfirmDialog from '../overlays/ConfirmDialog';

function TextNode({ id, data, selected }) {
    const { setNodes, setEdges, getNode } = useReactFlow();
    const [showDelete, setShowDelete] = React.useState(false);

    const confirmDelete = () => {
        setShowDelete(false);
        setNodes(n => n.filter(x => x.id !== id));
        setEdges(e => e.filter(x => x.source !== id && x.target !== id));
    };
    const handleDuplicate = (e) => {
        e.stopPropagation();
        const node = getNode(id);
        if (!node) return;
        setNodes(n => [...n, { ...node, id: `node_${Date.now()}`, position: { x: node.position.x+30, y: node.position.y+30 }, selected: false }]);
    };

    return (
        <div style={{ width:200, background:'#fff', border:`2px solid ${selected ? '#1565c0' : '#e5e7eb'}`, borderRadius:10, boxShadow:'0 2px 8px rgba(0,0,0,0.08)', overflow:'hidden' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'7px 10px', background:'linear-gradient(to right, #2388e0, #1565c0)' }}>
                <div style={{ display:'flex', alignItems:'center', gap:6, color:'#fff', fontSize:11, fontWeight:700 }}>
                    <i className="bi bi-chat-text" style={{ fontSize:12 }}></i> Send Text
                </div>
                <div style={{ display:'flex', gap:4 }}>
                    <button onClick={handleDuplicate} style={btnStyle} title="Duplicate"><i className="bi bi-copy" style={{ fontSize:10 }}></i></button>
                    <button onClick={e => { e.stopPropagation(); setShowDelete(true); }} style={btnStyle} title="Delete"><i className="bi bi-x" style={{ fontSize:12 }}></i></button>
                </div>
            </div>
            <div style={{ padding:'8px 10px' }}>
                <p style={{ fontSize:11, color:'#374151', lineHeight:1.5, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', margin:0 }}>
                    {data.sendText || data.text || 'Empty message'}
                </p>
            </div>
            <Handle id="a" type="target" position={Position.Left} style={handleStyle('#1565c0')}/>
            <Handle id="b" type="source" position={Position.Right} style={handleStyle('#1565c0')}/>
            {showDelete && <ConfirmDialog message={`Delete "${data.label || 'this node'}"?`} onConfirm={confirmDelete} onCancel={() => setShowDelete(false)}/>}
        </div>
    );
}

const btnStyle = { background:'none', border:'none', cursor:'pointer', color:'rgba(255,255,255,0.8)', padding:2, display:'flex', alignItems:'center' };
const handleStyle = (color) => ({ width:10, height:10, background:color, border:'2px solid #fff', borderRadius:'50%' });

export default TextNode;
